// Token stores the user's name, email, and type
import decode from "jwt-decode";

class Auth {
  getUser() {
    const token = decode(this.checkForToken());
    const user = token.data; // Get the User's data from token
    return user;
  }

  loggedIn() {
    const token = this.checkForToken();
    if (token === null) {
      return false; // no token available
    } else {
      const decoded = decode(token);
      // Check if Token is exp time is greater than the current time
      if (decoded.exp > Date.now() / 1000) {
        return true; // Token is still valid
      } else {
        return false; // Token is expired
      }
    }
  }

  checkForToken() {
    return localStorage.getItem("apc_session");
  }

  login(tokenData) {
    localStorage.setItem("apc_session", tokenData);
  }

  logout() {
    localStorage.removeItem("apc_session");
    window.location.assign("/"); // Send User to the homepage
  }
}

export default new Auth();
